// extracted by mini-css-extract-plugin
export default {"hardware":"Hardware_hardware__liwi7","title-pic":"Hardware_title-pic__2PpZB","car":"Hardware_car__XAHH4"};